import React from 'react';
import ResourceItem from './ResourceItem';
import SignedLink from './SignedLink';
import { ResourceContentTypes } from '../utils/constants';
import ProfessionalLink from './ProfessionalLink';
import ShareWrapper from 'chameleon-packages/units/components/ShareWrapper';

const Resource = ({ useClassroomResourceAddress, unitNumber, item }) => {
  const { displayName, description, url, id, contentType, isShareable } = item;
  const LinkComp =
    contentType === ResourceContentTypes.PROFESSIONAL_LINK
      ? ProfessionalLink
      : SignedLink;

  return (
    <ResourceItem key={id} iconName="resource_indicator">
      <LinkComp
        isSigned={false}
        useClassroomResourceAddress={useClassroomResourceAddress}
        aria-label={displayName}
        url={url}
      >
        <span className="font-medium hover:underline hover:text-black text-black text-base mr-4 leading-normal">
          {displayName}
        </span>
        <span className="font-normal hover:underline text-base hover:text-black text-black leading-normal">
          {description}
        </span>
      </LinkComp>
      {isShareable && (
        <div className="ml-auto">
          <ShareWrapper resource={item} unitNumber={unitNumber} />
        </div>
      )}
    </ResourceItem>
  );
};

export default Resource;
